import javaService from "../../utils/request"

 // 快讯
 export function globalSearch(data){
  return javaService({
    url: '/classificationFront/globalSearch',
    method: 'GET',
    params: data
  })
 }
